import BaseModelAPI from '../BaseModelAPI';

export default class MachineList extends BaseModelAPI {

	static entity = 'machinelist'
	static entityName = 'machine';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
